import { GET_STATES } from "../actions/types";

const initialState = {
    data: {
        states: [],
    },
    isLoading: false,
};

export default function (state = initialState, action: IReduxAction<any>) {
    switch (action.type) {
        case GET_STATES:
            return { ...state, data: action.payload }; // überschreibt den state
    }
    return state;
}
